import css from 'styled-jsx/css'
import { grids } from '../../styles'

export default css`
header {
  margin-left: ${grids.narrow.margin}px;
  position: relative;
  z-index: 1;
}

header.noTitle {
  display: none;
}

@media (min-width: 768px) {
  header {
    margin-left: ${grids.medium.margin}px;
  }
}

@media (min-width: 1024px) {
  header {
    margin-left: ${grids.medium.margin}px;
  }
}
`
